<div class="app-shell d-flex flex-column" [class.popout-route]="isPdfPopoutRoute">
  @if (!isPdfPopoutRoute) {
    <app-nav-bar></app-nav-bar>
  }

  <div class="app-content flex-grow-1 flex-shrink-1" [class.container]="!isPdfPopoutRoute"
    [class.popout-content]="isPdfPopoutRoute">
    <router-outlet></router-outlet>
  </div>

  @if (!isPdfPopoutRoute) {
    <app-footer></app-footer>
  }
</div>